import TenantLayout from "pages/Layout/Tenant/TenantLayout";
import React, { useEffect, useState } from "react";
import { isQldRegion } from "utils/petFormHelpers";
import Icon from "../../components/UI/Icon/Icon";
import { secureLocalStorage } from "../../utils/secureStorage";

const LandlordApplicationSuccess: React.FC = () => {
  const [agentName, setAgentName] = useState<string | null>(null);
  const [agentCompany, setAgentCompany] = useState<string | null>(null);

  useEffect(() => {
    const loadData = async () => {
      const name = await secureLocalStorage.getItem("agent_name");
      const company = await secureLocalStorage.getItem("agent_company");
      setAgentName(name);
      setAgentCompany(company);
    };
    loadData();
  }, []);

  return (
    <TenantLayout roleType="landlord">
      <div className="min-h-400px d-flex flex-column gap-40px align-items-center justify-content-center text-center">
        <div className="d-flex gap-30px align-items-center">
          <Icon name="dog" size={40} />
          <Icon name="cat" size={40} />
          <Icon name="bird" size={40} />
        </div>
        <div className="d-flex flex-column gap-40px">
          <div className="d-flex flex-column gap-10px">
            <div className="fs-18px fw-bold text-black">
              {isQldRegion()
                ? <>Your application has been submitted <br /> and sent to {agentName} at {agentCompany}</>
                : <>You are now required to sign the document <br /> in order to finalise the application</>
              }
            </div>
            {!isQldRegion() && (
            <div className="fs-16px text-grey">
               Please check your inbox and/or SMS messages for instructions on signing.
            </div>
            )}
          </div>

          <div className="fs-16px text-grey">
            {!isQldRegion() && (
              <><span className="fw-bold">What happens after you sign:</span> <br /></>
            )}
            We will send this application to {agentName} at {agentCompany}.
          </div>
        </div>
      </div>
    </TenantLayout>
  );
};

export default LandlordApplicationSuccess;
